export default "__VITE_ASSET__BxxLHN0N__"